export default __webpack_public_path__ + "static/media/message.48223b74.svg";